import { render, staticRenderFns } from "./CandidateProfileTFW.vue?vue&type=template&id=3717be19&scoped=true"
import script from "./CandidateProfileTFW.vue?vue&type=script&lang=js"
export * from "./CandidateProfileTFW.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfileTFW.vue?vue&type=style&index=0&id=3717be19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717be19",
  null
  
)

export default component.exports